
import {useState,useEffect,useMemo,Fragment} from 'react';
import {STTableProp,STTableColumnDetail,STTableRow} from '../STTableProps';
import { FormProvider, useForm } from "react-hook-form";
import moment from "moment";
import TableSortMenu from './TableSortMenu';
import { Stack, IconButton,Divider,Menu,MenuItem, Grid} from '@mui/material';
// import { BtnClear,BtnSearch } from "src/components/Button/ButtonAll"; 
// import ControlFilter from "src/components/STTable/components/ControlFilter";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ControlFilter from './ControlFilter';
import { BtnClear, BtnSearch } from 'components/Button/ButtonAll';
export default function TableMenu(param: STTableProp, item: STTableColumnDetail) {
    const form = useForm({
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
      });
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const  [open,setOpen] = useState(false);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
         setAnchorEl(event.currentTarget);
         setOpen(true);
    };
    const handleClose = () => {
        setAnchorEl(null);
        setOpen(false);
    };
    const [sortshow, setSortshow] = useState(item.order === 'asc' ? 'desc' : 'asc');
    useEffect(() => {
        setSortshow(item.order === 'asc' ? 'desc' : 'asc')
    }, [item.order])
    let objFilter = param.filterField.find(f => f.sFieldName === item.field);
    let sFieldName =item.field;
    let sIDFilter = `filter_${param.sTableID}_${item.field}`;
    if(objFilter)
    {
      sFieldName = objFilter.fieldSearch ? objFilter.fieldSearch : item.field;
      sIDFilter = `filter_${param.sTableID}_${sFieldName}`;
    }


      const handleSetValueDateRange = (item, form, sIDFilter) => {
        if (param.rows[sFieldName]) {
          form.setValue(sIDFilter, [
            param.rows[sFieldName][0]
              ? moment(param.rows[sFieldName][0])
              : null,
            param.rows[sFieldName][1]
              ? moment(param.rows[sFieldName][1])
              : null,
          ]);
        }
      };
    
      const handleSetValueDate = (item, form, sIDFilter) => {
        form.setValue(
          sIDFilter,
          param.rows[sFieldName] ? moment(param.rows[sFieldName]) : null
        );
      };
    const addFilterDateRange = (e, sIDFilter, cloneData, item) => {
      const data = e[sIDFilter];
      const typeData = typeof data;
      if (
        data &&
        data.length > 0 &&
        (data[0] || data[1]) &&
        typeData.toString() !== "undefined"
      ) {
        cloneData[sFieldName] = [
          data[0] ? moment(data[0]).format("YYYY-MM-DD[T]00:00:00[.000Z]") : null,
          data[1] ? moment(data[1]).format("YYYY-MM-DD[T]00:00:00[.000Z]") : null,
        ];
      }
      return cloneData;
    };
  
    const addFilterDate = (e, sIDFilter, cloneData, item) => {
      const data = e[sIDFilter];
      const typeData = typeof data;
      if (data && typeData.toString() !== "undefined") {
        cloneData[sFieldName] = moment(data).format(
          "YYYY-MM-DD[T]00:00:00[.000Z]"
        );
      }
      return cloneData;
    };
  
    const addFilterInput = (e, sIDFilter, cloneData, item) => {
      
      const data = form.getValues(sIDFilter);
      const typeData = typeof data;
      if (
        data &&
        typeData.toString() !== "undefined" &&
        data.toString().length > 0
      ) {
        cloneData[sFieldName] = data;
      }
      return cloneData;
    };
  
    const addFilterSelect = (e, sIDFilter, cloneData, item) => {
      const data = form.getValues(sIDFilter);
      // const typeData = typeof data;
      cloneData[sFieldName] = data;
      return cloneData;
    };
    const _setValue = () => {
      
        let objFilter = param.filterField.find(f => f.sFieldName === item.field);
      if (objFilter)
        {
          let sFieldName = objFilter.fieldSearch ? objFilter.fieldSearch :objFilter.sFieldName;
        let sIDFilter = `filter_${param.sTableID}_${sFieldName}`;
        switch (objFilter.sTypeFilterMode) {
          case "input": {
            form.setValue(sIDFilter, param.rows[sFieldName]);
            break;
          }
          case "select": {
            form.setValue(sIDFilter, param.rows[sFieldName]);
            break;
          }
          case "multiselect": {
            form.setValue(sIDFilter, param.rows[sFieldName]);
            break;
          }
          case "daterange": {
            handleSetValueDateRange(objFilter, form, sIDFilter);
            break;
          }
          case "date": {
            handleSetValueDate(objFilter, form, sIDFilter);
            break;
          }
        }
      }
    };
  
    useMemo(() => {
      _setValue();
    
    }, [open]);
    const onSearch = (e : STTableRow) => {
      
      let cloneData = { ...e};
      if (param.filterField) {
        let objFilter = param.filterField.find(f => f.sFieldName === item.field);
        if(objFilter)
        {
          switch (objFilter.sTypeFilterMode) {
            case "input": {
              cloneData = addFilterInput(e, sIDFilter, cloneData, objFilter);
              break;
            }
            case "select": {
              addFilterSelect(e, sIDFilter, cloneData, objFilter);
              break;
            }
            case "multiselect": {
              addFilterSelect(e, sIDFilter, cloneData, objFilter);
              break;
            }
            case "daterange": {
              cloneData = addFilterDateRange(e, sIDFilter, cloneData, objFilter);
              break;
            }
            case "date": {
              cloneData = addFilterDate(e, sIDFilter, cloneData, objFilter);
              break;
            }
          }
        }
      
      }
      handleClose();
      param.onLoadData(cloneData);
    };
    const onClear = (e : STTableRow) => {
      if (param.filterField) {
        let cloneData = { ...e};
        param.filterField.forEach((item) => {
          let sFieldNameParam = item.fieldSearch ? item.fieldSearch : item.sFieldName;
          let sIDFilter = `filter_${param.sTableID}_${sFieldNameParam}`;
          form.setValue(sIDFilter, undefined);
          cloneData[sFieldNameParam] = null;
        });
        handleClose();
        onSearch(cloneData);
      }
     
    };
    
    return <Fragment>
        <IconButton
            aria-label="more"
            id={"menu-table-" + item.field}
            aria-controls={open ? "menu-table-" + item.field : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-haspopup="true"
            onClick={handleClick}
        >
            <MoreVertIcon sx={{color:"white"}}/>
        </IconButton>
        <Menu
            id="long-menu"
            MenuListProps={{
                'aria-labelledby': "menu-table-" + item.field,
            }}
             anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
       
            autoFocus={false}
            disableAutoFocusItem={true}
            disableEnforceFocus
  disableRestoreFocus
            
        >
            {
                item.orderactive ?

                    <Grid>
                        {
                            TableSortMenu(param,item, handleClose, sortshow)
                        }
                        <MenuItem onClick={() => { handleClose() }}>
                            Clear Sort
                        </MenuItem>
                    </Grid>
                    : <Grid>
                        {
                            TableSortMenu(param,item,handleClose, 'asc')
                        }
                        {
                            TableSortMenu(param,item,handleClose, 'desc')
                        }
                    </Grid>
            }
              {
          param.modeFilter === 3 && objFilter ?
          <Fragment>
           <Divider/>
              <Stack px={0.5} py={2}>
          <FormProvider {...form}>
            <Stack spacing={2}>
              {
                objFilter ? ControlFilter(
                  objFilter,
                  param.column,
                  param.isLoading,
                  param.sTableID
                ) : null
              }
                 <Divider/>
              <Stack spacing={1} direction={'row'} justifyContent={'space-between'}>
                <BtnClear id="btnClear" IsRadius={false} onClick={()=>{onClear(param.rows)}}/>
                <BtnSearch id="btnSearch" IsRadius={false} 
                  onClick={()=>{onSearch(param.rows)}}
                // onClick={()=>{
                //   itemProps.sValue = form.getValues(sIDFilter);
                //   props.onSearch(itemProps);
                //   // itemProps.onClick();
                // }}
                
                />
              </Stack>
            </Stack>
          </FormProvider>

              </Stack>
          </Fragment>
          
          : null
        }
        </Menu>
    </Fragment>
}